var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayout1Col(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M38.396 10v36.837h7.06c2.174 0 3.808-.532 4.903-1.595C51.453 44.178 52 42.604 52 40.519V16.318c0-2.085-.547-3.66-1.641-4.723C49.264 10.532 47.629 10 45.456 10h-7.06zm-.008 0H10.544c-2.16 0-3.79.528-4.892 1.585C4.551 12.64 4 14.219 4 16.318v24.201c0 2.1.55 3.677 1.652 4.733 1.102 1.057 2.732 1.585 4.892 1.585h27.844V10z"
  }))));
}

export default SvgLayout1Col;